module.exports = __webpack_public_path__ + "img/shouquanzhongxin_banner.698c9f7c.png";